import React from 'react';

const AccordionContext = React.createContext<{ activeGroup: string | null, setActiveGroup?: React.Dispatch<React.SetStateAction<string | null>> }>({
    activeGroup: null
});

export default AccordionContext;